// Page routes need to be in order of the cart flow.
export const PAGE_ROUTES = {
  ADDRESS_CHECK: "/",
  UNSERVICEABLE_SOFT: "/unserviceable-soft",
  UNSERVICEABLE_HARD: "/unserviceable",
  UNSERVICEABLE_ALLCONNECT: "/unserviceable-allconnect",
  UNSERVICEABLE_ZIPLY: "/unserviceable-ziply",
  LIW: "/liw",
  EXISTING_CUSTOMER: "/existing-customer",
  SERVICEABLE_CATCH_ALL: "/serviceable",
  PLAN_PACKAGE: "/plan-package",
  CONTACT_CREDIT: "/contact-credit",
  BILLING_SUMMARY: "/order",
  CONFIRMATION: "/confirmation",
  GENERIC_ERROR: "/error",
  POSID_ERROR: "/posid",
  BUY_FIBER: "/fiber",
  PLAN_FIBER: "/plan-fiber",
  ORDER_FIBER: "/order-fiber",
  CONFIRMATION_FIBER: "/confirmation-fiber",
  RESUME: "/resume",
  BUILD: "/build",
  RECOMMENDATION: "/customize/recommendation",
  RECOMMENDATION_PROFILE: "/customize/profile",
  CHECKOUT: "/checkout",
  INSTALLATION: "/installation",
  BUY_FLOW_REDIRECT: "/buy-flow-redirect",
  QUIZ: "/customize/quiz",
};

export const PAGE_ROUTE_VALUES = Object.values(PAGE_ROUTES);
